module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjExODc1IDE1NjAgMTEgMTEiPg0KICA8ZGVmcz4NCiAgICA8c3R5bGU+DQogICAgICAuY2xzLTEgew0KICAgICAgICBmaWxsOiAjYjhiOWJhOw0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPHBhdGggaWQ9ImNsb3NlIiBjbGFzcz0iY2xzLTEiIGQ9Ik01LjUsNi45NjcsMS40NjcsMTEsMCw5LjUzNCw0LjAzNCw1LjUsMCwxLjQ2NywxLjQ2NywwLDUuNSw0LjAzNCw5LjUzNCwwLDExLDEuNDY3LDYuOTY3LDUuNSwxMSw5LjUzNCw5LjUzNCwxMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExODc1IDE1NjApIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader!./src/assets/images/icons/close.svg
// module id = BtYl
// module chunks = 53